import React from 'react';
import { twMerge } from 'tailwind-merge';
import { NextFutureImage } from '@components/main-components/image/NextFutureImage';
import blurImage from '@components/main-components/image/blur-image';

export function EditionCover({
  releaseTitle,
  releaseCover,
  className,
  imageSize,
  imageClassName,
}: {
  releaseTitle: string;
  releaseCover: string;
  className?: string;
  imageSize: number;
  imageClassName?: string;
}) {
  return (
    <div
      className={twMerge(
        'flex aspect-square items-center justify-center overflow-hidden rounded-md',
        className,
      )}
    >
      <NextFutureImage
        src={releaseCover}
        alt={releaseTitle}
        blurDataURL={blurImage(imageSize, imageSize)}
        width={imageSize}
        height={imageSize}
        placeholder="blur"
        className={twMerge('aspect-square', imageClassName)}
      />
    </div>
  );
}
